import { apiUpdate } from "../../API/Service/apiClient";

export const handleSizeImage_Upload =
 async(file, id,setLoaderADES) => {
  setLoaderADES({image:id});
  try {    
    const formData = new FormData();
    formData.append("id", id);
    formData.append("image", file);
    formData.append("action", 'image_upload');
    
    const resData = await apiUpdate("size", formData,
    {contentType: "multipart/form-data",});        
    if(resData?.data?.id > 0){      
    }else{
      alert("Something went wrong! Please try again")
    }
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoaderADES(null);
  }
}